import Modal from "react-modal";
import React, { useEffect } from "react";
import Styles from "./deomform.module.scss";
import { props } from "./types";
import cup from "../../../../Assets/cup.svg";
import { AiOutlineClose } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import useStore from "store";
import BookPromo from "../../Homepage/BookPromo";
Modal.setAppElement("#root");

const DemoForm = () => {
    const { setThankYouModal, ThankYouModal } = useStore((item: any) => item);

    const closeModal = () => {
        setThankYouModal(false);
    };
    // useEffect(() => {
    //     party.confetti(document.body, {
    //         count: party.variation.range(20, 40),
    //     });
    // }, []);
    return (
        <Modal
            isOpen={ThankYouModal}
            contentLabel="Modal"
            onRequestClose={closeModal}
            className={`${Styles["modal"]} ${Styles["thankyou"]}`}
            overlayClassName={Styles["overlay"]}>
            <button
                className={Styles["close-btn"]}
                onClick={closeModal}
                aria-label="Close">
                <AiOutlineClose />
            </button>
            <div className={Styles["thankyou-header"]}>
                <div className={Styles["icon-wrap"]}>
                    <img src={cup} alt="" />
                </div>
                <h3>Thank You!</h3>
                <p>
                    Your demo has been booked successfully. One of our
                    counsellors will reach out to you within 24–48 hours.
                </p>
                <p className={Styles["promo-banner"]}>
                    Enroll in October and your child's first 6 one-on-one
                    classes are covered by our money-back guarantee. If it's
                    not right for your child, we refund 100% of what you
                    paid — including the classes already taken.{" "}
                    <NavLink
                        to="/guarantee" target="_blank"
                        className={Styles["promo-link"]}
                        onClick={closeModal}>
                        See Guarantee Terms
                    </NavLink>
                </p>
                <BookPromo
                    placement="demo_thankyou"
                    variant="mini"
                    onLinkClick={closeModal}
                />
                <button className={Styles["cta"]} onClick={closeModal}>
                    Got it
                </button>
            </div>
            {/* <div className={Styles["body"]}>
                <h3>Did you check out these carefully-curated resources?</h3>
                <div className={Styles["Links"]}>
                    <NavLink to="/">
                        Free Resources Section <BsArrowRight />
                    </NavLink>
                    <NavLink to="/">
                        Paid Resources Section <BsArrowRight />
                    </NavLink>
                    <NavLink to="/">
                        Blog Resources Section <BsArrowRight />
                    </NavLink>
                </div>
            </div> */}
        </Modal>
    );
};
export default DemoForm;
